import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import PlaceIcon from "@mui/icons-material/Place";
import { useTheme } from "@mui/material/styles";

const LacorPartner = () => {
  const theme = useTheme();

  return (
    <Box sx={{ bgcolor: "background.default" }}>
      <Box
        sx={{
          px: { xs: 2, sm: 4 },
          py: { xs: 7, md: 10 },
          background: `linear-gradient(135deg, ${theme.palette.primary.dark}, ${theme.palette.primary.main})`,
          color: theme.palette.common.white,
          textAlign: "center",
        }}
      >
        <Chip
          label="Partner hospital"
          sx={{
            bgcolor: "rgba(255,255,255,0.1)",
            color: theme.palette.common.white,
            border: "1px solid rgba(255,255,255,0.2)",
            mb: 2,
            fontWeight: 800,
          }}
        />
        <Typography
          variant="h2"
          component="h1"
          sx={{
            fontFamily: "Georgia, 'Times New Roman', serif",
            fontStyle: "italic",
            fontWeight: 500,
            fontSize: { xs: "2.4rem", md: "4rem" },
          }}
        >
          St. Mary's Hospital Lacor
        </Typography>
        <Box
          sx={{
            mt: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            color: "rgba(255,255,255,0.84)",
          }}
        >
          <PlaceIcon sx={{ color: theme.palette.donate.primary }} />
          <Typography>Gulu, Northern Uganda</Typography>
        </Box>
      </Box>

      <Box sx={{ maxWidth: 1180, mx: "auto", px: { xs: 2, sm: 4 }, py: 7 }}>
        <Box
          sx={{
            bgcolor: "white",
            borderRadius: 2,
            border: "1px solid rgba(6, 57, 112, 0.1)",
            boxShadow: "0 18px 48px rgba(6, 57, 112, 0.12)",
            p: { xs: 2.5, md: 4 },
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "0.95fr 1.05fr" },
            gap: { xs: 3, md: 4 },
            alignItems: "center",
          }}
        >
          <Box>
            <Typography
              variant="h3"
              component="h2"
              sx={{
                color: theme.palette.primary.main,
                fontFamily: "Georgia, 'Times New Roman', serif",
                fontStyle: "italic",
                fontWeight: 500,
                mb: 2,
              }}
            >
              Why Lacor
            </Typography>
            <Typography sx={{ color: "text.secondary", lineHeight: 1.8 }}>
              St. Mary's Hospital Lacor is one of Northern Uganda's major
              hospitals, serving patients from Gulu and the wider region.
              Cyrenaeus' connection with Lacor is practical and personal:
              helping deliver reconstructive surgery, sharing specialist
              knowledge and supporting the teams who continue care after each
              visit.
            </Typography>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 1,
                mt: 3,
              }}
            >
              {[
                "Founded in 1959",
                "Teaching hospital",
                "500 beds",
                "300,000 treated annually",
              ].map((fact) => (
                <Box
                  key={fact}
                  sx={{
                    borderRadius: 2,
                    bgcolor: "rgba(6, 57, 112, 0.06)",
                    color: theme.palette.primary.main,
                    p: 1.5,
                    fontWeight: 800,
                    textAlign: 'center',
                    alignContent: 'center'
                  }}
                >
                  {fact}
                </Box>
              ))}
            </Box>
          </Box>

          <Box
            sx={{
              width: "100%",
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: "100%",
                aspectRatio: "16 / 9",
                borderRadius: 1.5,
                overflow: "hidden",
                bgcolor: theme.palette.primary.dark,
              }}
            >
              <iframe
                src="https://www.youtube.com/embed/KWHmtpFM4uE"
                title="St. Mary's Hospital Lacor"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                loading="lazy"
                style={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  border: 0,
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default LacorPartner;
